import axios from "axios";
import { TESTIMONIALS as MOCK_TESTIMONIALS } from "../mock";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, timeout: 15000 });

export const joinWaitlist = async (email) => {
  const { data } = await client.post("/waitlist", { email });
  return data;
};

export const submitContact = async ({ name, email, message }) => {
  const { data } = await client.post("/contact", { name, email, message });
  return data;
};

export const trackDownload = async (platform) => {
  try {
    const { data } = await client.post("/track-download", { platform });
    return data;
  } catch (e) {
    return null;
  }
};

export const fetchTestimonials = async () => {
  try {
    const { data } = await client.get("/testimonials");
    if (Array.isArray(data) && data.length > 0) return data;
    return MOCK_TESTIMONIALS;
  } catch (e) {
    return MOCK_TESTIMONIALS;
  }
};
